const debug = process.env.NODE_ENV !== 'production';

export function getAPIbaseURL() {
    if (debug) {
        return 'https://nfse.dev';
    } else {
        return 'https://api-nfse.dattasystem.com.br';
    }
}

export function getRelatorioURL() {
    if (debug) {
        return 'http://localhost:8088';
    } else {
        return 'https://relatorio-nfse.dattasystem.com.br';
    }
}

export function getSimplesNacionalURL() {
    if (debug) {
        return 'http://localhost:8801';
    } else {
        return 'https://api-simples.dattasystem.com.br';
    }
}

export function getEntidade() {
    let host = window.location.hostname;
    if (host.indexOf('www.') === 0) {
        host = location.host.replace('www.', '');
    }
    return host;
}
